'use strict';

/**
 * BD.AgeVerification: Show Age Verification popup
 */
var BD = window.BD = window.BD || {};
BD.AgeVerification = (function($) {
  const verificationCookie = "bd-ageVerification";
  
  function handleYesClicked() {
    var verified = Cookies.get(verificationCookie);
    Cookies.set(verificationCookie, 'true', { expires: 60 });
  }
  
  function handleNoClicked() { /* No action - "no" is just a close button */ }
  
  function init() {
    const $popup = $('#age-verification-modal');
    if (!$popup.length) { return; }

    var verified = Cookies.get(verificationCookie);
    
    if (verified !== 'true') {
      NA.Modal.triggerModal($popup);
      $popup.on('click', '.btn-yes', handleYesClicked);
      $popup.on('click', '.btn-no', handleNoClicked);
    }
  }
  
  $(init);
})(jQuery);